import {
    RESET_PASSWORD_ERROR,
    RESET_PASSWORD_ERROR_CLEAR,
    RESET_PASSWORD_PENDING,
    RESET_PASSWORD_SUCCESS,
} from "./constants"

const initialState = {
    isResetPasswordPending: false,
    resetPasswordErrorMessage: null,
    isSuccess: false,
}

const resetPassword = (state = initialState, action) => {

    switch (action.type) {
        case RESET_PASSWORD_PENDING: {
            return {
                ...state,
                isResetPasswordPending: true
            }
        }

        case RESET_PASSWORD_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                resetPasswordErrorMessage: errorMessage,
                isResetPasswordPending: false,
                isSuccess: false,
            }
        }

        case RESET_PASSWORD_ERROR_CLEAR: {
            return {
                ...state,
                resetPasswordErrorMessage: null,
                isResetPasswordPending: false,
                isSuccess: false,
            }
        }

        case RESET_PASSWORD_SUCCESS: {
            return {
                ...state,
                isSuccess: true,
                resetPasswordErrorMessage: null,
                isResetPasswordPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default resetPassword;